module.exports = __webpack_public_path__ + "static/yashar-d49cd597c9b13c05967bbc2e403c60ab.jpg";